import { useContext } from 'react'
import { AuthContext, type AuthContextValue } from './AuthProvider'
import type { AuthUser } from '@/api/types'

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>')
  return ctx
}

/** Use inside screens that only render when authenticated (under the app gate). */
export function useUser(): AuthUser {
  const { user } = useAuth()
  if (!user) throw new Error('useUser used outside an authenticated context')
  return user
}
